@if (propertyDetails) {
  <rma-static-google-map-with-description
    [markers]="mapMarker ? [mapMarker] : []"
    [config]="isPrintMode ? printMapConfig : mapConfig"
    [staticMapUrl]="printedUrl"
  >
    <span class="font-bond w-4/5 pb-2 text-center text-xl text-steel-70 md:text-left">{{
      'marketReports.property-details' | transloco
    }}</span>
    <span class="font-bond w-4/5 pb-2 text-center text-4xl md:text-left print:hidden">{{ propertyDetails.streetAddress }}</span>
    <span class="font-bond w-4/5 pb-2 text-center text-4xl md:text-left print:hidden">{{ propertyDetails.suburbLine }}</span>
    <span class="hidden w-full pb-2 text-4xl font-bold print:block"
      >{{ propertyDetails.streetAddress }}, {{ propertyDetails.suburbLine }}</span
    >
    <span class="w-4/5 text-center sm:text-left">
      <rma-property-attribute
        class="text-steel-70"
        [bathrooms]="propertyDetails.bathrooms"
        [bedrooms]="propertyDetails.bedrooms"
        [carparks]="propertyDetails.carparks"
        [propertyType]="propertyDetails.propertyType"
      />
    </span>
  </rma-static-google-map-with-description>
}
